import { ArrayDataSource } from '@skyscanner/backpack-web/bpk-component-infinite-scroll';

class FetchDataSource extends ArrayDataSource {
  constructor(
    fetchPage: Function,
    onFailed: Function,
    initialElements?: any[],
  ) {
    super(initialElements);

    this.fetchPage = fetchPage;
    this.onFailed = onFailed;
  }

  elementsAlreadyPresent(index: number, nElements: number) {
    return this.elements && index + nElements <= this.elements.length;
  }

  fetchItems(index: number, nElements: number) {
    if (this.elementsAlreadyPresent(index, nElements)) {
      return Promise.resolve(this.elements.slice(index, index + nElements));
    }
    return this.fetchPage(index, nElements).catch(this.onFailed);
  }
}

export default FetchDataSource;
